import { useEffect, useState } from 'react'
import { Modal } from './Modal'
import { Button } from './Button'
import { SITZUNG_ABGELAUFEN_EVENT } from '../api'
import { ereignisGilt } from '../sitzungBereich'

/**
 * §6.59 — „Deine Anmeldung ist abgelaufen." Owner 18.09.2026: Redesign
 * ("too boring") — ruhiger Icon-Anker + gestaffeltes Einblenden statt
 * reiner Titel+Text-Zeile, DESIGN.md §15.8. Vertrag nach außen unverändert:
 * aktiv/titel/text/knopf/onNeuAnmelden, beide Aufrufer unangetastet, keine
 * neuen i18n-Keys. `aktiv` = „es gab eine Sitzung": auf der Anmeldeseite
 * ist ein 401 normal und löst nichts aus. Einmal offen, bleibt er offen.
 */
export function SitzungAbgelaufenDialog({
  aktiv, gilt, titel, text, knopf, onNeuAnmelden,
}: {
  aktiv: boolean
  /** Nur 401 von Pfaden, fuer die das gilt, oeffnen den Dialog (sonst Schleife bei fremder Sitzung). */
  gilt?: (path: string) => boolean
  titel: string
  text: string
  knopf: string
  onNeuAnmelden: () => void
}) {
  const [offen, setOffen] = useState(false)
  useEffect(() => {
    if (!aktiv) { setOffen(false); return }
    const auf = (e: Event) => { if (ereignisGilt(gilt, e)) setOffen(true) }
    window.addEventListener(SITZUNG_ABGELAUFEN_EVENT, auf)
    return () => window.removeEventListener(SITZUNG_ABGELAUFEN_EVENT, auf)
  }, [aktiv, gilt])
  if (!offen) return null
  return (
    <Modal
      open onClose={onNeuAnmelden} size="sm" noHeader ariaLabel={titel}
      footer={<Button variant="primary" icon="login" size="xl" onClick={onNeuAnmelden}>{knopf}</Button>}
    >
      <div className="flex flex-col items-center text-center py-3 sm:py-4">
        <div className="w-14 h-14 rounded-full bg-surface-container-low border border-outline-variant flex items-center justify-center mb-5 opacity-0 animate-[fade-in-up_0.4s_ease-out_forwards] motion-reduce:animate-none motion-reduce:opacity-100">
          <span className="material-symbols-outlined !text-2xl text-on-surface-variant" aria-hidden="true">lock_clock</span>
        </div>
        <h2 className="text-lg font-semibold text-on-surface tracking-tight font-headline opacity-0 animate-[fade-in-up_0.4s_ease-out_60ms_forwards] motion-reduce:animate-none motion-reduce:opacity-100">
          {titel}
        </h2>
        <p className="text-sm text-on-surface leading-relaxed mt-2 max-w-[30ch] opacity-0 animate-[fade-in-up_0.4s_ease-out_120ms_forwards] motion-reduce:animate-none motion-reduce:opacity-100">
          {text}
        </p>
      </div>
    </Modal>
  )
}
